module.exports = __webpack_public_path__ + "assets/icon-add-gray.20689bb5.svg";